export default "__VITE_ASSET__Cqk7WH3H__"